/*
 * File: CustomNotes.tsx
 * Project: a-a
 * File Created: Wednesday, 9th April 2025 6:09:26 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Thursday, 24th July 2025 1:32:58 am
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import { Box, Divider, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import zeplinColor from '../../../theme/Color';
import CustomTextField from '../CustomTextField/CustomTextField';
import { validatePassword } from '../../../helper/validate';
import { useInput } from '../../../customHook/useInput';
import validator from 'validator';
import CustomButton from '../CustomButton/CustomButton';
import CustomNoteCard from './CustomNoteCard';
import { NotesService } from '../../../service/notes.service';
// import { parse } from 'path';
import CustomAlert from '../CustomAlert/CustomAlert';
import CustomAlertContain from '../CustomAlert/CustomAlertContain';
import CustomPopOver from '../CustomPopOver/CustomPopOver';
import { Link, useLocation } from 'react-router-dom';
import style from './CustomNotes.module.css';
const CustomNotes = ({
  id,
  parse_sf,
  setMsg,
  task,
}: {
  id: string;
  parse_sf: {
    access_token: string;
    id: string;
    instance_url: string;
    issued_at: string;
    refresh_token: string;
    scope: string;
    signature: string;
    token_type: string;
  };
  setMsg: React.Dispatch<
    React.SetStateAction<{
      message: string;
      type: 'Error' | 'Success';
    }>
  >;
  task: any;
}) => {
  const location = useLocation();
  const user = sessionStorage.getItem('user-name');
  const sessionNotes = sessionStorage.getItem('notes_content');
  const sf_token = sessionStorage.getItem('SFToken') || '';
  const {
    handleChange: handleNotesChange,
    handleBlur: handleNotesBlur,
    value: notes,
    invalid: invalidNotes,
    didChange: didNotesChange,
    setValue: setNotes,
  } = useInput('', () => {
    return false;
  });
  const handleAlertClose = () => {
    setMsg({ message: '', type: 'Success' });
  };
  const [notesResponse, setNotesResponse] = useState<
    {
      title: string;
      id: string;
      createdDate: string;
      createdByName: string;
      content: string;
    }[]
  >();
  const [loading, setLoading] = useState(false);
  const [taskAnchorEl, setTaskAnchorEl] = React.useState<HTMLDivElement | null>(null);
  const openTask = Boolean(taskAnchorEl);
  const idTask = openTask ? 'simple-popover' : undefined;
  const inputRef = useRef<null | HTMLDivElement>(null);
  const [editId, setEditId] = useState('');

  // const [msg, setMsg] = useState<{ message: string; type: 'Error' | 'Success' }>({
  //   message: '',
  //   type: 'Success',
  // });

  const addNotes = async (title: string) => {
    try {
      const res = await NotesService.addNotes({
        taskId: id,
        noteContent: title,
        noteTitle: user || '',
        createdByName: user || '',
        // access_token: parse_sf?.access_token,
      });
      // console.log(addNotes);
      setNotes('');
      sessionStorage.removeItem('notes_content');
      setMsg({ message: `Note added successfully`, type: 'Success' });
      await getNotes();
    } catch (err: any) {
      setMsg({ message: `Something went wrong`, type: 'Error' });
    }
  };
  const editNotes = async (title: string) => {
    try {
      setLoading(true);
      const res = await NotesService.EditNotes({
        noteId: editId,
        noteContent: title,
        noteTitle: user || '',

        // access_token: parse_sf?.access_token,
      });
      console.log(res);
      setNotes('');
      setEditId('');
      setMsg({ message: `Notes edited successfully`, type: 'Success' });
      await getNotes();
    } catch (err: any) {
      setMsg({ message: `Something went wrong`, type: 'Error' });
    } finally {
      setLoading(false);
    }
  };
  const deleteNotes = async (id: string) => {
    try {
      setLoading(true);
      const res = await NotesService.deleteNotes(id, {
        // access_token: parse_sf?.access_token,
      });
      // console.log(res);
      setEditId('');
      setMsg({ message: `Notes deleted successfully`, type: 'Success' });
      await getNotes();
    } catch (err: any) {
      setMsg({ message: `Something went wrong`, type: 'Error' });
    } finally {
      setLoading(false);
    }
  };
  const getNotes = async () => {
    try {
      setLoading(true);
      const res = await NotesService.getAllNotes(id);
      setNotesResponse(res.notes || []);
      console.log(res);
    } catch (err: any) {
      setMsg({ message: `Something went wrong`, type: 'Error' });
    } finally {
      setLoading(false);
    }
  };
  const handleAddClick = (e: React.MouseEvent<HTMLDivElement>) => {
    setTaskAnchorEl(e.currentTarget);
    sessionStorage.setItem('sf_path', location?.pathname);
    sessionStorage.setItem('sf_redirect', 'Task');
    sessionStorage.setItem('sf_edit_selected', JSON.stringify(task));

    sessionStorage.setItem('notes_content', notes);
    sessionStorage.setItem('sf_task_status', task?.status);
  };
  useEffect(() => {
    parse_sf && getNotes();
  }, []);
  useEffect(() => {
    if (sessionNotes) {
      setNotes(sessionNotes);
    }
  }, [sessionNotes]);
  useEffect(() => {
    notes?.length > 40 && inputRef?.current?.focus();
  }, [notes]);
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      <Box sx={{ display: 'flex', gap: '8px', padding: '0px 24px 0px 24px' }}>
        <img src={'/assets/note.png'} width={'20px'} height={'20px'} />
        <Typography variant='responsiveBody2' color={zeplinColor.Neutral8}>
          Notes
        </Typography>
      </Box>
      {notesResponse?.length || loading ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: '16px', xl: '32px' },
            padding: '0px 24px 0px 24px',
          }}
        >
          {notesResponse?.map((val) => (
            <CustomNoteCard
              data={val}
              setNotes={setNotes}
              editNotes={editNotes}
              setEditId={setEditId}
              editId={editId}
              deleteNotes={deleteNotes}
              loading={loading}
              parse_sf={parse_sf}
              sfToken={sf_token}
              task={task}
              key={val?.id}
            />
          ))}
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '0px 24px 0px 24px',
          }}
        >
          {' '}
          <img src={'/assets/no-notes.png'} className={style['no-notes-icon']} />
          <Typography
            variant='responsiveHeading3'
            color={zeplinColor.BasicBlack}
            sx={{ marginTop: { xs: '12px', xl: '24px' } }}
          >
            No Notes Yet
          </Typography>
          <Typography
            variant='responsiveBody3'
            color={zeplinColor.Neutral8}
            sx={{ width: '70%', textAlign: 'center', marginTop: { xs: '6px', xl: '12px' } }}
          >
            Add notes to ensure no detail gets missed.
          </Typography>
        </Box>
      )}

      <Box
        sx={{
          width: '100%',
          position: 'sticky',
          bottom: '0px',
          margin: 'auto',
          zIndex: '100',
          padding: '24px 24px 24px 24px',
          backgroundColor: zeplinColor.Neutral1,
        }}
      >
        <CustomTextField
          ref={inputRef}
          multiline={notes?.length > 40 ? true : false}
          style={{
            width: '100%',
            margin: 'auto',
            '& .MuiOutlinedInput-notchedOutline': { border: `1px solid ${zeplinColor.Neutral5}` },
          }}
          onBlur={handleNotesBlur}
          onChange={handleNotesChange}
          name='notes'
          text={notes}
          error={''}
          label={editId ? 'Edit a note' : 'Add a note'}
          type='notes'
          tabindex={1}
          endIcon={
            <CustomButton
              onClick={(e: any) => {
                !parse_sf?.access_token
                  ? handleAddClick(e)
                  : editId
                  ? editNotes(notes)
                  : addNotes(notes);
              }}
              variant='contained'
              disabled={notes?.trim() && !loading ? false : true}
              color={notes?.trim().length ? 'primary' : 'customDisable'}
              style={{
                width: '40px',
                borderRadius: '10px',
                height: '40px',
                '& .MuiButton-startIcon': { margin: 0 },
              }}
              //   textStyle={{ color: otp.length === 6 ? zeplinColor.Neutral1 : zeplinColor.Neutral8 }}
              text={''}
              icon={
                // <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <img
                  src={
                    notes?.trim() && !loading
                      ? '/assets/up-arrow-white.png'
                      : '/assets/up-arrow.png'
                  }
                  className={style['icons']}
                  style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                />
                // </Box>
              }
            />
          }
        />
      </Box>
      <CustomPopOver
        setAnchorEl={setTaskAnchorEl}
        anchorEl={taskAnchorEl}
        id={idTask}
        sx={{
          borderRadius: '14px',
          boxShadow: 'rgba(0, 0, 0, 0.15)',
          marginTop: '8px',
          // marginRight: '2rem',
          // marginLeft: '-4rem',
        }}
      >
        <Box
          sx={{
            height: '202px',
            width: '340px',
            padding: '24px',
            display: 'flex',
            gap: { xs: '26px', xl: '32px' },
            flexDirection: 'column',
          }}
        >
          <Box sx={{ display: 'flex', gap: { xs: '10px', xl: '16px' }, flexDirection: 'column' }}>
            <Box
              sx={{
                display: 'flex',
                gap: { xs: '6px', xl: '12px' },
                justifyContent: 'space-between',
              }}
            >
              <Typography variant='heading3' color={zeplinColor.BasicBlack}>
                Authentication Required
              </Typography>
              <img
                src={'/assets/close-icon.svg'}
                width={24}
                height={24}
                alt='close'
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  setTaskAnchorEl(null);
                  sessionStorage.removeItem('notes_id');
                  sessionStorage.removeItem('notes_content');
                }}
              />
            </Box>

            <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
              {/* To create a new task, please ensure you're logged in to your Salesforce account. */}
              You need to be logged into Salesforce to perform this action. Please log in to your
              Salesforce account.
            </Typography>
          </Box>
          <Link
            // target='_blank'
            // rel='noopener noreferrer'
            to={`https://${process.env.REACT_APP_SALESFORCE_URI}/services/oauth2/authorize?client_id=${process.env.REACT_APP_CLIENT_SALESFORCE}&redirect_uri=${process.env.REACT_APP_REDIRECT}&response_type=code`}
          >
            <CustomButton
              disabled={false}
              onClick={() => {}}
              variant='contained'
              color={'primary'}
              style={{
                width: '155px',
                borderRadius: '14px',
                height: '48px',
                padding: '14px 16px',
                '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
              }}
              textStyle={{ color: zeplinColor.Neutral1 }}
              text={'Open Salesforce'}
              // tabindex={4}
            />
          </Link>
        </Box>
      </CustomPopOver>
    </Box>
  );
};

export default CustomNotes;
